import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0dcf610e")
const _hoisted_1 = {
  shadow: "xl",
  noBorder: ""
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-1 initial-swap-fee" }, "Initial swap fee", -1)
const _hoisted_3 = { class: "text-gray-600 initial-swap-fee-p my-[16px]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "px-1" }, "%", -1)
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "mb-1 text-gray-600" }
_popScopeId()

import { isAddress } from 'ethers/lib/utils';
import { computed, nextTick, ref } from 'vue';

import usePoolCreation from '@/composables/pools/usePoolCreation';
import useNumbers from '@/composables/useNumbers';
import { isRequired, isValidAddress } from '@/lib/utils/validations';
import useWeb3 from '@/services/web3/useWeb3';


export default _defineComponent({
  emits: ['update:height'],
  setup(__props, { emit }) {



/**
 * STATIC
 */
const FIXED_FEE_OPTIONS = ['0.001', '0.003', '0.01'];

/**
 * STATE
 */
const isCustomFee = ref(false);
const checkboxState = ref(true);
const isInvalidFee = ref(false);
const cardWrapper = ref<HTMLElement>();

/**
 * COMPOSABLES
 */
const { fNum2 } = useNumbers();
const {
  initialFee,
  feeController,
  feeManagementType,
  feeType,
  setFeeManagement,
  setFeeType,
  setFeeController,
  setTrpController,
  thirdPartyFeeController,
  fee,
  proceed,
  goBack,
  isLoadingSimilarPools,
} = usePoolCreation();
const { account } = useWeb3();
const { userNetworkConfig } = useWeb3();

/**
 * COMPUTED
 */
const customInputClasses = computed(() => ({
  'border border-blue-500 text-blue-600 dark:text-blue-400': isCustomFee.value,
  'border dark:border-gray-900': !isCustomFee.value,
}));

const isProceedDisabled = computed(() => {
  if (
    feeController.value === 'other' &&
    !isAddress(thirdPartyFeeController.value)
  ) {
    return true;
  }

  if (isInvalidFee.value) return true;

  return false;
});

// this does not need to be computed as it relies on a static
const feeOptions = FIXED_FEE_OPTIONS.map(option => {
  return {
    label: fNum2(option, {
      style: 'percent',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
      fixedFormat: true,
    }),
    value: option,
  };
});

/**
 * FUNCTIONS
 */
function onFixedInput(val: string): void {
  initialFee.value = '0';
  initialFee.value = val;
  isCustomFee.value = false;
}

function onCustomInput(val: string): void {
  initialFee.value = (Number(val) / 100).toString();
  isCustomFee.value = true;

  if (Number(val) < 0.0001 || Number(val) > 10) {
    isInvalidFee.value = true;
  } else {
    isInvalidFee.value = false;
  }
}

async function onChangeFeeManagementType(val: boolean) {
  if (!val) {
    setFeeManagement('self');
  } else {
    setFeeManagement('governance');
    setFeeType('fixed');
    setFeeController('self');
    setTrpController('');
  }
  await nextTick();
  emit('update:height', {
    height: cardWrapper.value?.offsetHeight || 0,
  });
}

async function onChangeFeeType(val: string) {
  if (val === 'fixed') {
    setFeeController('self');
    setTrpController('');
  }
  await nextTick();
  emit('update:height', {
    height: cardWrapper.value?.offsetHeight || 0,
  });
}

async function onChangeFeeController(val: string) {
  if (val === 'self') {
    setTrpController('');
  }
  await nextTick();
  emit('update:height', {
    height: cardWrapper.value?.offsetHeight || 0,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_BalBtnGroup = _resolveComponent("BalBtnGroup")!
  const _component_BalStack = _resolveComponent("BalStack")!
  const _component_BalAlert = _resolveComponent("BalAlert")!
  const _component_BalCheckbox = _resolveComponent("BalCheckbox")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!
  const _component_BalRadio = _resolveComponent("BalRadio")!
  const _component_BalTextInput = _resolveComponent("BalTextInput")!
  const _component_BalBtn = _resolveComponent("BalBtn")!

  return (_openBlock(), _createElementBlock("div", { ref: cardWrapper }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BalStack, { vertical: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_BalStack, {
            vertical: "",
            spacing: "sm"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_2,
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('createAPool.bestFeeOption')), 1)
              ]),
              _createVNode(_component_BalStack, {
                spacing: "xs",
                horizontal: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BalBtnGroup, {
                    modelValue: _unref(initialFee),
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => (_isRef(initialFee) ? initialFee.value = $event : null)),
                      onFixedInput
                    ],
                    options: _unref(feeOptions)
                  }, null, 8, ["modelValue", "options"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['custom-input', _unref(customInputClasses)])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => (_isRef(fee) ? fee.value = $event : null)),
                          onCustomInput
                        ],
                        class: "h-full w-12 bg-transparent text-right",
                        placeholder: "0.1",
                        type: "number",
                        step: "any"
                      }, null, 512), [
                        [_vModelText, _unref(fee)]
                      ]),
                      _hoisted_4
                    ], 2)
                  ])
                ]),
                _: 1
              }),
              (isInvalidFee.value)
                ? (_openBlock(), _createBlock(_component_BalAlert, {
                    key: 0,
                    class: "w-full",
                    title: _ctx.$t('invalidFee'),
                    type: "error"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('invalidFeeExplain')), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_BalStack, {
            horizontal: "",
            spacing: "none",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BalCheckbox, {
                modelValue: checkboxState.value,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => (checkboxState.value = $event)),
                  onChangeFeeManagementType
                ],
                name: "areFeesGovernanceManaged",
                size: "sm",
                label: _ctx.$t('createAPool.governanceFees'),
                noMargin: ""
              }, null, 8, ["modelValue", "label"]),
              _createVNode(_component_BalTooltip, {
                text: _ctx.$t('createAPool.governanceFeesTooltip'),
                iconSize: "sm",
                class: "mt-1 ml-2"
              }, null, 8, ["text"])
            ]),
            _: 1
          }),
          (_unref(feeManagementType) === 'self')
            ? (_openBlock(), _createBlock(_component_BalStack, {
                key: 0,
                vertical: "",
                spacing: "sm"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.$t('createAPool.alternativeFeeManagement')), 1),
                  _createVNode(_component_BalRadio, {
                    modelValue: _unref(feeType),
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => (_isRef(feeType) ? feeType.value = $event : null)),
                      onChangeFeeType
                    ],
                    value: "fixed",
                    name: "feeManagementOptions"
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('createAPool.fixedFeeRadioLabel')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_BalRadio, {
                    modelValue: _unref(feeType),
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => (_isRef(feeType) ? feeType.value = $event : null)),
                      onChangeFeeType
                    ],
                    value: "dynamic",
                    name: "feeManagementOptions"
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('createAPool.dynamicFeeRadioLabel')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(feeType) === 'dynamic')
            ? (_openBlock(), _createBlock(_component_BalStack, {
                key: 1,
                vertical: "",
                spacing: "sm"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.$t('createAPool.setAnAddress')), 1),
                  _createVNode(_component_BalRadio, {
                    modelValue: _unref(feeController),
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => (_isRef(feeController) ? feeController.value = $event : null)),
                      onChangeFeeController
                    ],
                    value: "self",
                    name: "addressOption"
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('createAPool.myAddressOption', [_ctx._shorten(_unref(account))])), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_BalRadio, {
                    modelValue: _unref(feeController),
                    "onUpdate:modelValue": [
                      _cache[6] || (_cache[6] = ($event: any) => (_isRef(feeController) ? feeController.value = $event : null)),
                      onChangeFeeController
                    ],
                    value: "other",
                    name: "addressOption"
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('createAPool.customAddressOption')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(feeController) === 'other' && _unref(feeType) === 'dynamic')
            ? (_openBlock(), _createBlock(_component_BalStack, {
                key: 2,
                vertical: "",
                spacing: "xs"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.$t('createAPool.customAddressTitle')), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('createAPool.customAddressInfo')), 1),
                  _createVNode(_component_BalStack, {
                    vertical: "",
                    spacing: "xs"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BalTextInput, {
                        modelValue: _unref(thirdPartyFeeController),
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(thirdPartyFeeController) ? thirdPartyFeeController.value = $event : null)),
                        placeholder: "0xBA4...2069",
                        type: "text",
                        size: "sm",
                        validateOn: "blur",
                        rules: [
                _unref(isRequired)(_ctx.$t('A controller address')),
                _unref(isValidAddress)(),
              ],
                        name: "customAddress"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_BalBtn, {
            disabled: _unref(isProceedDisabled) || _unref(isLoadingSimilarPools),
            type: "submit",
            block: "",
            color: "gradient",
            loading: _unref(isLoadingSimilarPools),
            onClick: _unref(proceed)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading", "onClick"])
        ]),
        _: 1
      })
    ])
  ], 512))
}
}

})